module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/display-2-16f2d1bd226e390c76d26066eae09639.svg";